import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const SortAsc = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.8542 16.3438L12.3542 18.8438C12.2708 18.9479 12.1563 19 12.0104 19C11.8646 19 11.75 18.9479 11.6667 18.8438L9.16667 16.3438C9 16.1979 8.95833 16.0208 9.04167 15.8125C9.125 15.6042 9.28125 15.5 9.51042 15.5H11.0104V5.5C11.0104 5.35417 11.0573 5.23438 11.151 5.14062C11.2448 5.04688 11.3646 5 11.5104 5H12.5104C12.6563 5 12.776 5.04688 12.8698 5.14062C12.9635 5.23438 13.0104 5.35417 13.0104 5.5V15.5H14.5104C14.7396 15.5 14.8958 15.6042 14.9792 15.8125C15.0625 16.0208 15.0208 16.1979 14.8542 16.3438Z"
            fill={color}
        />
    </StarryUIIcon>
);
